/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Scoped_AccessInputs */

const en_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoped access`)
};

const ar_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وصول محدود النطاق`)
};

const bn_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোপড অ্যাক্সেস`)
};

const de_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereichsbezogener Zugriff`)
};

const es_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso con alcance`)
};

const fr_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès limité`)
};

const pt_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso com escopo definido`)
};

const zh_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`范围访问`)
};

const tr_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapsamlı erişim`)
};

const ru_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограниченный доступ`)
};

const pl_svchip_scoped_access = /** @type {(inputs: Svchip_Scoped_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostęp ograniczony`)
};

/**
* | output |
* | --- |
* | "Scoped access" |
*
* @param {Svchip_Scoped_AccessInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_scoped_access = /** @type {((inputs?: Svchip_Scoped_AccessInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Scoped_AccessInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_scoped_access(inputs)
	if (locale === "bn") return bn_svchip_scoped_access(inputs)
	if (locale === "de") return de_svchip_scoped_access(inputs)
	if (locale === "es") return es_svchip_scoped_access(inputs)
	if (locale === "fr") return fr_svchip_scoped_access(inputs)
	if (locale === "pt") return pt_svchip_scoped_access(inputs)
	if (locale === "zh") return zh_svchip_scoped_access(inputs)
	if (locale === "tr") return tr_svchip_scoped_access(inputs)
	if (locale === "ru") return ru_svchip_scoped_access(inputs)
	if (locale === "pl") return pl_svchip_scoped_access(inputs)
	return en_svchip_scoped_access(inputs)
});